import { Icons } from "../../../Icons/Icons";

export const dropdownItems = [
  {
    id: 0,
    icon: Icons.profile,
    title: "Login/Signup",
    link: "/sign-up",
  },
  {
    id: 1,
    icon: Icons.setting,
    title: "General settings",
    link: "/",
  },
  {
    id: 2,
    icon: Icons.pricing,
    title: "Pricing",
    link: "/",
  },
  {
    id: 3,
    icon: Icons.contact,
    title: "Contact Us",
    link: "/",
  },
  {
    id: 4,
    icon: Icons.info,
    title: "How it works",
    link: "/",
  },
];
export const paymentData = [
  {
    id: 1,
    title: "Pay Monthly",
    children: {
      money: "30k",
    },
  },

  {
    id: 2,
    title: "Lifetime",
    children: {
      money: "60k",
    },
  },
  {
    id: 3,
    title: "Pay yearly",
    children: {
      money: "250k",
    },
  },
];
